import styles from "../../assets/scss/components/coverPage.module.scss";
import BucclLogo from "../../assets/images/icons/buccl_logo_B.png";
import { useNavigate } from "react-router-dom";

const CoverPage = ({ hasTab = false, title, desc, btnText, btnClick }) => {
    const navigate = useNavigate();
    return (
        <div
            className={`${styles["cover-page"]} ${
                hasTab ? styles["has-tab"] : ""
            }`}
        >
            <img src={BucclLogo} alt="buccl-logo" width={60} />
            <p className={styles["cover-page-text"]}>
                {title || "버킷리스트를 만들어보세요."}
            </p>
            <p className={styles["cover-page-text-sub"]}>
                {desc ||
                    `회원가입 후 더 많은 서비스를 경험하세요. 
               버킷리스트에서 함께 더 넓은 세상을 만나요.`}
            </p>
            <button
                className={`btn  btn-border-round btn-small btn-fit btn-outline-purple500 ${styles["cover-page-btn"]}`}
                onClick={() => {
                    if (btnClick) {
                        btnClick();
                    } else {
                        navigate("/login");
                    }
                }}
            >
                {btnText || "오늘 도전하기"}
            </button>
        </div>
    );
};

export default CoverPage;
